import React, { useState } from "react";
import axios, { axiosAuth } from "react-axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FeatureCallOutContainer from "~/Containers/FeatureCallOutContainer";
import { ThemeProvider, DEFAULT_THEME } from "@zendeskgarden/react-theming";
import { Tooltip } from "@zendeskgarden/react-tooltips";
import styled from "styled-components";
import { setTrackFavorite } from "~/api/getTrack";
import { getGenreSetFavorite } from "~/api/getGenre";
import { setArtistFavorite } from "~/api/getArtist";

import { useUser } from "~/Context/userContext";
// import LoginModal from "~/Components/Elements/Global/LoginModal";
import LoginModal from "@dreamchimney/user-login";
import Auth from "./Auth";
import "~/css/nav.less";

export const NavWrapper = styled.section`
  margin-bottom: 30px;
`;
export const AskCreate = styled.section`
  .create-account {
    text-decoration: underline;
    &:hover {
      cursor: pointer;
      text-decoration: none;
    }
  }
`;

export const LoginLinkWrapper = styled.section`
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 12px;
  text-decoration: underline;
  z-index: 1000;
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`;

const DropDownUser = (userState) => (
  <div>
    <Dropdown.Item as={Link} to={{ pathname: `/user/${userState.user.dir}`, state: "flush" }}>
      View Profile
    </Dropdown.Item>
    <Dropdown.Item as={Link} to={`/user/${userState.user.dir}/edit`}>
      Edit Profile
    </Dropdown.Item>
    {/* <Dropdown.Item as={Link} to={`/profile/${userState.user.dir}/favorites`}>
      Your Favorites
    </Dropdown.Item> */}
  </div>
);
const DropDownChim = (userState) => (
  <div>
    <Dropdown.Item as={Link} to={`/menu`}>
      Post a Track
    </Dropdown.Item>
    <Dropdown.Item as={Link} to={{ pathname: `/profile/${userState.user.dir}`, state: "flush" }}>
      View Profile
    </Dropdown.Item>
    <Dropdown.Item as={Link} to={`/profile/edit/details`}>
      Edit Profile
    </Dropdown.Item>
    <Dropdown.Item as={Link} to={`/profile/${userState.user.dir}/favorites`}>
      Your Favorites
    </Dropdown.Item>
    <Dropdown.Item as={Link} to={`/profile/${userState.user.dir}/playlists`}>
      Your Playlists
    </Dropdown.Item>
    <Dropdown.Item as={Link} to={`/menu/news`} onClick={() => window.gtag('event', 'totd_click', { eventLabel: `News` })}>
      News/Updates
    </Dropdown.Item>
  </div>
);

const MainNav = () => {
  const { state: userState, dispatch } = useUser();
  const [hover, setHover] = useState(false);

  const toggleDropdown = (e) => {
    if (e.type === "mouseleave") setHover(false);
    else if (e.type === "mouseenter") setHover(true);
    else setHover(true);
  };
  const hideDropdown = (e) => {
    setHover(false);
  };

  const handleLoginAction = (payload) => {
    const { dispatch: payloadDispatch = {} } = payload;
    const promiseActions = [];

    // Add genre favorite after login/register
    const loginSetGenreFav = localStorage.getItem("login_genre_fav") || false;
    if (loginSetGenreFav) {
      const {
        payload: { jwt = null },
      } = payloadDispatch;
      const setFavGenre = getGenreSetFavorite(axios, loginSetGenreFav, jwt).then((data) => localStorage.removeItem("login_genre_fav"));
      promiseActions.push(setFavGenre);
    }

    // Add artist favorite after login/register
    const loginSetArtistFav = localStorage.getItem("login_artist_fav") || false;
    if (loginSetArtistFav) {
      const {
        payload: { jwt = null },
      } = payloadDispatch;
      const obj = JSON.parse(loginSetArtistFav);
      const setFavArtist = setArtistFavorite(axios, obj.artistFavId, obj.artistName, jwt).then((data) =>
        localStorage.removeItem("login_artist_fav")
      );
      promiseActions.push(setFavArtist);
    }

    // Add track favorite after login/register
    const loginSetTrackFav = localStorage.getItem("login_track_fav") || false;
    if (loginSetTrackFav) {
      const {
        payload: { user = {} },
      } = payloadDispatch;
      const setFavTrack = setTrackFavorite(axios, loginSetTrackFav, { chim: user && user.dir }).then((data) =>
        localStorage.removeItem("login_track_fav")
      );
      promiseActions.push(setFavTrack);
    }

    Promise.all(promiseActions).then((values) => {
      dispatch(payloadDispatch);
    });
  };

  const logoutHandler = () => dispatch({ type: "logout", payload: {} });

  const loginToggle = () => dispatch({ type: "signin_open" });
  const modalClosed = () => dispatch({ type: "signin_close" });

  return (
    <NavWrapper>
      <Auth className="">
        {!userState.loggedin && (
          <LoginLinkWrapper className="login-wrapper" onClick={() => loginToggle()}>
            Login
          </LoginLinkWrapper>
        )}
        <Row noGutters className="totd-micro-nav">
          <Col xs={12}>
            {userState.loggedin && (
              <div className="micro-nav-item item-home">
                <ThemeProvider
                  theme={{
                    ...DEFAULT_THEME,
                    rtl: true,
                    colors: { ...DEFAULT_THEME.colors, background: "#4a4a9b", neutralHue: "#fff" },
                  }}
                >
                  <FeatureCallOutContainer
                    featureId="totd_register_profile_tip"
                    clickAwayDismiss={false}
                    render={({ show, markAsViewed }) => (
                      <div className="navToolTip">
                        <Tooltip
                          type="light"
                          zIndex="100"
                          isInitialVisible={false}
                          isVisible={userState.loggedin && !userState.isChim && show}
                          placement="top"
                          size="large"
                          content={
                            <>
                              <h3>Welcome</h3>
                              <p>View and edit your favorite tracks, playlists and profile here</p>
                              <div>
                                <button onClick={markAsViewed}>OK</button>
                              </div>
                            </>
                          }
                        >
                          <Dropdown show={hover} onMouseEnter={toggleDropdown} onMouseLeave={toggleDropdown} onToggle={toggleDropdown}>
                            <Dropdown.Toggle>
                              <FontAwesomeIcon icon="user" className="user" />
                              {userState.isChim && `${userState.user.full_name} Chimney`}
                              {!userState.isChim && `${userState.user.full_name}`}
                            </Dropdown.Toggle>
                            <Dropdown.Menu onClick={hideDropdown}>
                              {userState.isChim && DropDownChim(userState)}
                              {!userState.isChim && DropDownUser(userState)}
                              <Dropdown.Item onClick={() => logoutHandler()}>Logout</Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </Tooltip>
                      </div>
                    )}
                  />
                </ThemeProvider>
              </div>
            )}
            <div className="micro-nav-item micro-nav-item-main item-home">
              <Link to="/">
                <FontAwesomeIcon icon="compact-disc" className="compact-disc" />
                <span>Tracks</span>
              </Link>
            </div>
            <div className="micro-nav-item micro-nav-item-main item-mb">
              <Link to={{ pathname: `/message-board`, state: "flush" }}>
                <FontAwesomeIcon icon="comments" className="comments" />
                <span>Message Board</span>
              </Link>
            </div>
            <div className="micro-nav-item micro-nav-item-main item-search">
              <Link to="/search">
                <FontAwesomeIcon icon="search" className="search" />
                <span>Search</span>
              </Link>
            </div>
          </Col>
        </Row>
        {/* <LoginModal show={userState.signin} show_fav={userState.signin_show_fav} onClose={modalClosed} /> */}
        <LoginModal
          show={userState.signin}
          register={userState.register}
          show_fav={userState.signin_show_fav}
          onClose={modalClosed}
          onLoggedin={handleLoginAction}
          onRegister={handleLoginAction}
        />
      </Auth>
    </NavWrapper>
  );
};

export default MainNav;
